// /src/components/NavContainerNoSidebar.tsx

// What? A container for the navigation bar without the workspace sidebar.
// Why? To display the navigation bar and the content of the container.
// How?
// - Uses the Upperbar component to display the upper bar.
// - Uses the children prop to display the content of the container.

import React from "react";
import { Box } from "@mui/joy";
import Upperbar, { UPPERBAR_HEIGHT_PX } from "./Upperbar";

interface NavContainerNoSidebarProps {
  children: React.ReactNode;
}

const NavContainerNoSidebar: React.FC<NavContainerNoSidebarProps> = ({
  children,
}) => {
  // CSS variable logic removed - using natural layout flow

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        boxSizing: "border-box",
        pt: `${UPPERBAR_HEIGHT_PX}px`,
      }}
    >
      <Upperbar />
      <Box
        component="main"
        sx={{
          flex: 1,
          backgroundColor: "background.body",
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default NavContainerNoSidebar;
